import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from '@tanstack/react-router';
import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';

import '@awesome.me/webawesome/dist/components/input/input.js';
import '@awesome.me/webawesome/dist/components/button/button.js';
import '@awesome.me/webawesome/dist/components/callout/callout.js';

import { APIpasswordReset } from '../api/Auth';

const PasswordReset: React.FC = () => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);

  const { mutate, isPending, isError } = useMutation({
    mutationFn: async (data: { email: string }) => {
      const response = await APIpasswordReset(data.email);
      return response;
    },
    onError: (error) => {
      setErrorMessage(error.message || 'An error occurred.');
    },
    onSuccess: () => {
      setErrorMessage(null);
      setSuccess(true);
    },
  });

  const schema = z.object({
    email: z.string({ message: "Email is required" }),
  });

  const { register, handleSubmit, formState: { errors } } = useForm<{ email: string }>({
    resolver: zodResolver(schema) as any,
  });

  const onSubmit = (data: { email: string }) => {
    mutate({ email: data.email });
  };

  return (
    <div className="container password-reset-container">
      <div className="wa-grid wa-gap-0">
        <div className="password-reset-form">
          {isError && (
            <wa-callout variant="danger">
              <i className="fa-regular fa-circle-exclamation" slot="icon"></i>
              <strong>{errorMessage}</strong>
            </wa-callout>
          )}
          {success ? (
            <wa-callout variant="success">
              <i className="fa-regular fa-circle-check" slot="icon"></i>
              <strong>Password reset email sent!</strong>
              <p>Please check your inbox for instructions to reset your password.</p>
            </wa-callout>
          ) : (
            <>
              <form onSubmit={handleSubmit(onSubmit)} noValidate>
                <wa-input type="email" label="E-mail" required className={`${errors.email ? 'invalid' : ''}`} autofocus {...register('email')} placeholder="Enter your email" hint={errors.email?.message}></wa-input>
                <div className="center">
                  <wa-button type="submit" disabled={isPending}>
                    {isPending ? 'Sending...' : 'Reset password'}
                  </wa-button>
                </div>
              </form>
              <div className="password-reset-info">
                Don't have an account? <Link to="/signup">Sign up here</Link>.
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default PasswordReset;
